import { event } from 'vue-gtag';

export function sendButtonClickEvent(origin: string, target: string) {
  event('button_click', {
    origin: origin,
    target: target,
  });
}
export function sendTabNavEvent(origin: string, target: string) {
  event('tab_navigation', {
    origin: origin,
    target: target,
  });
}

export function sendDialogOpenEvent(origin: string, target: string) {
  event('dialog_open', {
    origin: origin,
    target: target,
  });
}
